//import '../sass/_componentA.scss';
import { Component } from "@basic-orange/component";

export default class ComponentA extends Component {
    constructor(elm, componentId) {
        super(elm, componentId);
    }
}